import {OnQueryStartedFunctionAttrType} from "@/types/generic/OnQueryStartedFunctionAttr.type";
import {UpdateAmenitiesRequestType, UpdateAmenitiesResponseType} from "@CheckOrder/api/types/UpdateAmenitiesQuery.type";
import {setCheckOrderPassengers, setPassengerDataUpdating, setTicket} from "@CheckOrder/reducers/checkOrderSlice";
import consolidatePassengers from "@CheckOrder/api/functions/consolidatePassengers";
import {setError} from "@Reducers/pageSlice";

export default function updateAmenitiesQuery(): OnQueryStartedFunctionAttrType<UpdateAmenitiesRequestType, UpdateAmenitiesResponseType> {
    return async (request, {dispatch, queryFulfilled}) => {
        dispatch(setPassengerDataUpdating(true))

        try {
            const response = await queryFulfilled

            if (response.meta.response.ok) {
                const passengers = consolidatePassengers(
                    request.passengers,
                    response.data.checkOrder.passengers
                )

                dispatch(setTicket({ticket: response.data.checkOrder.ticket, keepPassengerClasses: true}))
                dispatch(setCheckOrderPassengers(passengers))
                dispatch(setPassengerDataUpdating(false))
            }
        } catch (err) {
            dispatch(setError({
                error: "Failed to update amenities",
                info: `ticket: ${request.ticketCode}, single amenities: ${JSON.stringify(request.singleAmenities)}, return amenities: ${JSON.stringify(request.returnAmenities)}`,
            }))
            dispatch(setPassengerDataUpdating(false))
        }
    }
}